/* @flow */

import upperFirst from 'lodash/upperFirst';

const BLACKLIST = [
    'a',
    'e',
    'o',
    'do',
    'dos',
    'da',
    'das',
    'de',
    'com',
    'que',
];

const upper = (palavra: string) => (!BLACKLIST.includes(palavra) ? upperFirst(palavra) : palavra);

const titleize = (title: string) => title.split(' ').map(upper).join(' ');

export default titleize;
